<template>
  <div>
    <el-table
        :data="tableData"
        height="600"
        :header-cell-style="{background:'#f2f2f2',color:'#222'}"
        border
        style="width: 100%">
      <el-table-column
          v-for="item in tableColumn"
          align="center"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label">
      </el-table-column>
      
    </el-table>
  </div>
</template>

<script>
import {getDetailsYieldGroupProvinceList} from '@/api/steel'
export default {
  data() {
    return {
      tableData: [],
      tableColumn: [
        {
          prop: 'provinceName', label: '省份'
        },{
          prop: 'price1', label: '粗钢月同比（%）'
        },{
          prop: 'price2', label: '粗钢产量（万吨）'
        },{
          prop: 'price3', label: '粗钢累计（万吨）'
        },{
          prop: 'price4', label: '生铁月同比（%）'
        },{
          prop: 'price5', label: '生铁产量（万吨）'
        },{
          prop: 'price6', label: '生铁累计（万吨）'
        },{
          prop: 'price8', label: '钢材月同比（%）'
        },{
          prop: 'price7', label: '钢材产量（万吨）'
        },{
          prop: 'price9', label: '钢材累计（万吨）'
        },{
          prop: 'price10', label: '钢材累计同比（%）'
        },
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      getDetailsYieldGroupProvinceList({endTime:this.$route.query.id}).then(res => {
        this.tableData = res.data;
      })
    },
  },
}
</script>

<style scoped lang="less">
.slot-span {
  display: inline-block;
  text-align: center;
  line-height: 25px;
  width: 74px;
  height: 25px;
  background: #F2F2F2;
  border-radius: 4px;
  border: 1px solid #CCCCCC;
  cursor: pointer;
}

.echarts {
  margin-top: 24px;
  width: 1200px;
  height: 400px;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px 0px rgba(183, 183, 183, 0.5);
  padding: 30px;
}
</style>
